/*eslint-disable*/
import React, {useEffect} from "react";
import { Link } from "react-router-dom";

import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";


export default function Admin() {
  const screenSize = (window.innerWidth >= 912);
  const screenSizeTwo = (window.innerWidth >= 1024);

  useEffect(() => {
  }, []);

  document.title = "Admin Home";

  return (
    <>
      <section>
        <AuthNavbar />
      </section>

      <section className="relative grad-1 pb-20">
        <div className="container relative mx-auto pt-12 px-4 w-10/12">
          <h2 className="text-36 text-yellow mb-6">Admin</h2>

          <div className="relative w-full">

            <div className="flex flex-wrap">

              <div className="w-full md:w-12 lg:w-12 px-4 mb-4">
                <div className="relative flex flex-col w-full">
                  <div className="w-full bg-white-7 rounded-lg h-200-px flex items-center px-12">
                    <div className="w-full">

                        <table className="bg-transparent even:bg-blue-950">
                          <tbody>
                          <tr>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td className="pb-4 text-14-400 text-white">Review the status of imported data:</td>
                            <td><Link
                                className="get-started text-blue text-center text-16-19-bold px-8 py-3 rounded mb-1 bg-yellow block w-full"
                                to="/importlog"
                            >
                              Import Log
                            </Link></td>
                          </tr>
                          <tr>
                            <td className="pb-4 text-14-400 text-white">Review Admin User Activity:</td>
                            <td><Link
                                className="get-started text-blue text-center text-16-19-bold px-8 py-3 rounded mb-1 bg-yellow block w-full"
                                to="/activitylog"
                            >
                              Activity Log
                            </Link></td>
                          </tr>
                          <tr>
                            <td className="pb-4 text-14-400 text-white">Manage displayed available opportunities:</td>
                            <td><Link
                                className="get-started text-blue text-center text-16-19-bold px-8 py-3 rounded mb-1 bg-yellow block w-full"
                                to="/opportunitylist"
                            >
                              Map display
                            </Link></td>
                          </tr>
                          <tr>
                            <td className="pb-4 text-14-400 text-white">Manage Application Users and Permissions:</td>
                            <td><Link
                                className="get-started text-blue text-center text-16-19-bold px-8 py-3 rounded mb-1 bg-yellow block w-full"
                                to="/userlist"
                            >
                              Users
                            </Link></td>
                          </tr>
                          <tr>
                            <td className="pb-4 text-14-400 text-white">Manage Funder Display Details:</td>
                            <td><Link
                                className="get-started text-blue text-center text-16-19-bold px-8 py-3 rounded mb-1 bg-yellow block w-full"
                                to="/funderlist"
                            >
                              Funders
                            </Link></td>
                          </tr>
                          <tr>
                            <td className="pb-4 text-14-400 text-white">Manage Funder Capital:</td>
                            <td><Link
                                className="get-started text-blue text-center text-16-19-bold px-8 py-3 rounded mb-1 bg-yellow block w-full"
                                to="/fundercapital"
                            >
                              Funder Capital
                            </Link></td>
                          </tr>
                          <tr>
                            <td className="pb-4 text-14-400 text-white">Manage Api Keys:</td>
                            <td><Link
                                className="get-started text-blue text-center text-16-19-bold px-8 py-3 rounded mb-1 bg-yellow block w-full"
                                to="/apikeys"
                            >
                              Api Keys
                            </Link></td>
                          </tr>
                          </tbody>
                        </table>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>

    </>
  );
}

